import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const PrintTemplates = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Yazdırma Şablonları
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Yazdırma şablonları burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default PrintTemplates;
